export default __webpack_public_path__ + "static/media/yourname.63c24ece.jpg";